module.exports = __webpack_public_path__ + "img/b6-1.e3f3a62.png";